export default __webpack_public_path__ + "static/LeituraSansTwo-Medium-c3583c248af4394b582a2735193e2356.woff2";